import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { CpUploadFilesResponseModel } from '../../helpers/objects/response/upload-files/cp-upload-files-response-model';
import { CpFileTypesModel } from '../../helpers/objects/dto/setup-file-types/cp-file-types-model';

@Injectable({
  providedIn: 'root'
})
export class CpUploadFilesService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  upload(file: File, isInvoice = false): Observable<CpUploadFilesResponseModel> {
    const formData: FormData = new FormData();
    formData.append('filename', file);
    const headers = new HttpHeaders({ 'X-Isinvoice': isInvoice.toString() });
    return this.http.post<any>(this.appConfig.api + 'files', formData, { headers }).pipe(map((response) => response.body as CpUploadFilesResponseModel));
  }

  setup(): Observable<CpFileTypesModel[]> {
    return this.http.get<any>(this.appConfig.api + 'files/setup').pipe(map((response) => response.body.mimetypes as CpFileTypesModel[]));
  }

  getTemplateSetup(contractType: string, documentType: string): Observable<any> {
    const contract = atob(sessionStorage.getItem('contract')!);
    const token = sessionStorage.getItem('token');
    return this.http.get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/companies-files/' + contractType + '/setup').pipe(
      map((response) => {
        if (response.body.documents.find((document: any) => document.documentType === 'CLIENT_AREA_COMPANY_BENEFICIARIES')) {
          return (
            this.appConfig.api +
            'contracts/' +
            encodeURIComponent(contract) +
            '/companies-files/' +
            contractType +
            '/setup/' +
            documentType +
            '?Authorization=' +
            token +
            '&X-Partnership=' +
            this.appConfig.apiPartnershipId
          );
        }
        return response;
      })
    );
  }
}
